import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { HttpService } from '@app/services/http.service';
import { environment } from '@env/environment';
import { Role } from '../../../models/role';
import { ActivatedRoute, Router } from '@angular/router';
import { Code } from '@app/models/code';
import { takeUntil, tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AppComponent } from '@app/app.component';
import { PageTitleService } from '@app/services/page-title.service';
import { LoaderService } from '@app/services/loader.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseComponent } from '@app/base.component';

@Component({
  selector: 'app-code-create',
  templateUrl: './code-create.component.html',
  styleUrls: ['./code-create.component.css']
})
export class CodeCreateComponent extends BaseComponent implements OnInit {

  // variables
  private isLoaded: boolean = false;
  isRegister: boolean = true;
  subTitle: string = "Create Code";
  hidePassword: boolean = true;
  activeRoles: Role[];
  urlBack: string = null;
  codeId: number = null;
  code: Code = null;

  // code form
  codeForm = new UntypedFormGroup({
    code: new UntypedFormControl( null, { validators: [Validators.required, Validators.pattern('^[0-9A-Z.]*$')] }),
    code_order: new UntypedFormControl( null, { validators: [Validators.required, Validators.pattern('^[0-9]*$')] }),
    description: new UntypedFormControl( null, {validators: [Validators.required] }),
    description_long: new UntypedFormControl( null, {validators: [Validators.required] }),
    is_active: new UntypedFormControl( null, {}),
    code_type: new UntypedFormControl( null, { validators: Validators.required })
  });

  // form field data
  codeTypes: Array<{id: string, name: string}> = [ 
    { id: 'CPT', name: 'CPT' },
    { id: 'ICD-10', name: 'ICD-10' }
  ];

  constructor(
    private httpService: HttpService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private appComponent: AppComponent,
    private pageTitleService: PageTitleService,
    private loaderService: LoaderService,
    private snackBarService: MatSnackBar
  ) {
    super();
    this.urlBack = this.router.createUrlTree(['/administration/codes']).toString();
    this.activatedRoute.params.subscribe(params => {
      if (params.code_id) {
        this.codeId = params.code_id;
        this.isRegister = false;
        this.subTitle = "Create Code"
      }

      const urlApi = this.httpService.createUrl([
        'api',
        'roles'
      ], {}, { host: environment.host_api_default });
      this.isLoaded = true;
      this.loaderService.hide();
    });
  }

  handleBack(): void {
    this.router.navigateByUrl(this.urlBack);
  }

  isFormLoaded(): boolean {
    return this.isLoaded;
  }
  // handle whether or not submit button should be active
  getIsSubmitActive(): boolean {
    return !this.codeForm.valid;
  }
  
  // handle form submit
  handleSubmit(): void {
    if (this.codeForm.valid) {
      this.loaderService.show();
      this.createCode();
    }
  }

  createCode(): void {
    const urlApi = this.httpService.createUrl([
      'api',
      'codes'
    ], {}, { host: environment.host_api_default});

    let create = this.httpService.post(urlApi, this.codeForm.value);
    create.subscribe({
      next: (code) => {
        this.loaderService.hide();
        this.codeId = code['code_id'];

        const urlCodeView = this.router.createUrlTree([
          'administration',
          'codes',
          this.codeId
        ]);

        this.router.navigateByUrl( urlCodeView );
      }, error: (e) => {
        this.loaderService.hide();
        this.snackBarService.open(`Error creating code: ${e.error.message}`, `Ok`, {
          duration: 5000,
          panelClass: ['snackbar-full-width']
        });
      }

    });
  }

  ngOnInit(): void {
    this.pageTitleService.setPageTitle('Code Administration');
    this.appComponent.appendSiteTitle('administration', 'codes', 'create')
  }
}
